<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">订单管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">订单列表</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <!-- <a-select style="width: 120px" allowClear @change="orderhandleChange" placeholder="订单状态" :showArrow="show">
                    <a-select-option v-for="(option,x) in orderoption" :key="x" :value="option.id">
                        {{option.name}}
                    </a-select-option>
                </a-select> -->
                <!-- 标签 -->
                <!-- <a-select style="width: 120px" allowClear @change="typehandleChange" placeholder="支付状态" :showArrow="show">
                    <a-select-option v-for="(option,x) in typeoption" :key="x" :value="option.id">
                        {{option.name}}
                    </a-select-option>
                </a-select> -->

                <a-button type="danger" @click="delusers" >删除签约订单</a-button>
            </div>
            <!-- 来源 -->

            <div class="right" style="display:flex">
                <!-- <a-input v-model="telephone_jh" style="width:160px;margin-right:6px" placeholder="激活号码"></a-input> -->
                <a-input-search
                    placeholder="关键字（用户名/订单号）"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                    
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"  rowKey="id" :scroll="{x: 1300}" :pagination="pageshow" :columns="columns" :data-source="data">
                    <router-link slot="name" slot-scope="text,record" :to="{path:'orderdetail',query: {id:record.orid}}" >
                        {{ text }}
                    </router-link>

                    <span slot="image" slot-scope="text">
                        <img @click="toBig(text)" style="width:100px;cursor:pointer" :src="text" alt="">
                    </span>

                    <span slot="datetime" slot-scope="text">
                        <span v-if="text">{{text | showDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <!-- <a style="color:#1890ff;display:flex;align-items: center;" slot="phone" slot-scope="text,record" @click="totel(record.id)">
                        <a-icon type="phone" theme="filled"/> <span style="margin-left:3px">{{text}}</span>
                    </a> -->
                    <span slot="action" slot-scope="text,record">
                        <a  href="javascript:;" @click="toedit(record.id)" style="margin-right:12px"><a-icon type="edit" /> 修改</a> 

                        <a  href="javascript:;" @click="delclue(record.id)" ><a-icon type="delete" /> 删除</a> 
                        
                        
                        <!-- <a href="javascript:;" @click="todelive(record.orid)" style="margin-right:12px"><a-icon type="export" /> 发货</a>                        
                        <router-link :to="{path:'orderdetail',query: {id:record.orid}}"><a-icon type="copy"/> 详情</router-link> -->
                    </span>
                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

        <!-- 更改信息 -->
        <a-modal
        title="更改信息"
        :visible="editvisible"
        @cancel="handleCancel"
        cancelText="取消"
        okText="确定"
        @ok="edithandleOk"
        >
              <div style="height:400px;overflow-y:auto">
                 <a-form class="dataform" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="签约标题">
                    <a-input placeholder="签约标题" v-model="orderinfo.title"></a-input>
                </a-form-item>
                <a-form-item label="签约内容">
                    <a-textarea placeholder="签约内容" v-model="orderinfo.content" :rows="4"></a-textarea>
                </a-form-item>
                <a-form-item label="合同">
                     <a-upload
                        name="file"
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        action="/api/wechat/addimg"
                        @change="hthandleChange"
                        :headers="headers"
                    >
                        <img v-if="orderinfo.contract" :src="orderinfo.contract" alt="avatar" />
                        <div v-else>
                            <!-- <a-icon :type="loading ? 'loading' : 'plus'" /> -->
                            <div class="ant-upload-text">上传</div>
                        </div>
                    </a-upload>
                </a-form-item>
                <a-form-item label="凭证">
                     <a-upload
                        name="file"
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        action="/api/wechat/addimg"
                        @change="pzhandleChange"
                        :headers="headers"
                    >
                        <img v-if="orderinfo.voucher" :src="orderinfo.voucher" alt="avatar" />
                        <div v-else>
                            <!-- <a-icon :type="loading ? 'loading' : 'plus'" /> -->
                            <div class="ant-upload-text">上传</div>
                        </div>
                    </a-upload>
                </a-form-item>
                <a-form-item label="资质">
                     <a-upload
                        name="file"
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        action="/api/wechat/addimg"
                        @change="zzhandleChange"
                        :headers="headers"
                    >
                        <img v-if="orderinfo.qualifications" :src="orderinfo.qualifications" alt="avatar" />
                        <div v-else>
                            <!-- <a-icon :type="loading ? 'loading' : 'plus'" /> -->
                            <div class="ant-upload-text">上传</div>
                        </div>
                    </a-upload>
                </a-form-item>

                <a-form-item label="签约备注">
                    <a-textarea v-model="orderinfo.remarks" placeholder="签约备注" :rows="4"></a-textarea>
                </a-form-item>


              
            </a-form>
              </div>
        </a-modal>


        <!-- 发货 -->
        <!-- <a-modal
        title="发货"
        :visible="delivevisible"
        @cancel="handleCancel"
        cancelText="取消"
        okText="发货"
        @ok="khhandleOk"
        >
            <div class="deliver" >

                <div class="orderinfo orderform">
                    <span class="title">姓名：</span><span>{{orderinfo.username}}</span>
                    <span class="title" style="margin-left: 20px;">电话：</span><span>{{orderinfo.telephone}}</span>
                    <span class="title" style="margin-left: 20px;">卡数：</span><span>{{orderinfo.num}}</span>
                    <p><span class="title">地址：</span>{{orderinfo.province}}{{orderinfo.city}}{{orderinfo.area}}{{orderinfo.address}}</p>
                    <p><span class="title">套餐：</span>{{orderinfo.title_goods_setmeal}}</p>

                </div>
                <a-form class="dataform" :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                    <a-form-item label="订单号" >
                        <a-input v-model="orderno" disabled=""/>
                    </a-form-item>
                    <a-form-item label="快递单号" >
                        <a-input v-model="order.tracknumber" />
                    </a-form-item>
                    <div v-for="(i) in goodslist" :key="i.gdid">
                        <a-form-item label="手机号" ref="telephone" >
                            <a-input v-model="i.telephone" />
                        </a-form-item>
                        <a-form-item label="ICCID" ref="iccid" >
                            <a-input v-model="i.iccid" />
                        </a-form-item>
                        <a-divider />
                    </div>

                </a-form>
            </div>
            
        </a-modal> -->


        <!-- 图片预览 -->
         <div class="pimages" v-viewer style="display:none" :navbar="false">
            <img v-for="src in signImages" :key="src" :src="src">
        </div>
    </div>
    
</template>

<script>
import Vue from 'vue'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({
  navbar: false,title:false
});

import {formatDate} from '../../utils/formate.js'
import addresslist from '../../../static/address.json'
import { Modal } from 'ant-design-vue';
const columns = [
    {title: 'ID',dataIndex: 'id',key: 'id',width:80},
    {title: '签约标题',dataIndex: 'title',key: 'title',width:160},
    {title: '签约内容',dataIndex: 'content',key: 'content',width:360},
    {title: '合同',dataIndex: 'contract',key: 'contract',width:120,scopedSlots: { customRender: 'image' }},
    {title: '凭证',dataIndex: 'voucher',key: 'voucher',width:120,scopedSlots: { customRender: 'image' }},
    {title: '资质',dataIndex: 'qualifications',key: 'qualifications',width:120,scopedSlots: { customRender: 'image' }},
    {title: '备注',dataIndex: 'remarks',key: 'remarks',width:260},
    {title: '添加时间',dataIndex: 'addtime',key: 'addtime',scopedSlots: { customRender: 'datetime' },width:160},
    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' },fixed: 'right',width:160},
];

export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      },

      showDate(time){
          time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd hh:mm:ss')
      }
    },
    props: {
		inputNums: {
			type: Number,
			default: 19
		},
		value: {
			type: String,
			default: ''
		}
	},
    data(){
        const adddata = [];
        return{
            code: this.value.split(''),
            
            editvisible:false,
            show:true,
            lyoption:["来源1","来源2"],
            orderoption:[{name:'全部',id:""},{name:'未发货',id:"0"},{name:'已发货',id:"1"},{name:'已签收',id:"2"},{name:'拒收',id:"3"}],
            typeoption:[{name:'全部',id:""},{name:'已支付',id:"1"},{name:'已退款',id:"3"}],
            kdoption:["快递一"],
            searchtext:"",
            tstext:"",
            tablespinning:true,
            tabley:"",
            tablex:"100%",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            columns,
            data:[],
            pagination:{
                total:20
            },
            totalpage:2,
            pageshow:false,
            currentpagination:"",
            pageSizeOptions:['10','20','30','40','100','200'],

            delivevisible:false,
            form: this.$form.createForm(this, { name: 'coordinated' }),
            ordernum:[{"id":0}],
            position:0,
            size:10,

            iccidlist:[],
            len:0,
            order:{
                orid:"",
                state:1,
                tracknumber:""
            },
            orderno:"",//订单号
            goodslist:[],
            orderinfo:"",

            city:"",
            area:"",
            address:"",
            province:"",

            editid:"",
            state_pay:"",
            state:"",

            addressinfo:"",
            ssq:[],

            msgname:"",
            msgtel:"",
            msgorderno:"",
            
            telephone_jh:"",

            selectedRowKeys:[],

            headers:{"token":localStorage.getItem('token')},

        }
    },
    watch: {
        windowHeight (val) {
            this.tablex=val-300
        },
        value(newVal){
            this.code = newVal.split('');
        },
        code(newVal){
            this.$emit('input',newVal.join(''));
        }
    },
    created(){
        //修改的data值为JSON文件中想要的数据
        this.adddata = addresslist;
    },

    mounted(){
        
        this.fetch()

        window.fullWidth = document.documentElement.clientWidth;
        this.windowWidth = window.fullWidth;  
        this.tablex=this.windowWidth-300
        window.onresize = () => {
            return (() => {
                window.fullWidth = document.documentElement.clientWidth;
                this.windowWidth = window.fullWidth;  // 高
                this.tablex=this.windowWidth-300
            })()
        };
    },
    methods:{
          // 合同、凭证、资质图片上传
        hthandleChange(info){
            this.orderinfo.contract=info.file.response.data.url
        },
        pzhandleChange(info){
            this.orderinfo.voucher=info.file.response.data.url
        },
        zzhandleChange(info){
            this.orderinfo.qualifications=info.file.response.data.url
        },
        // 图片预览
         toBig(src){
            this.signImages=[]
            this.signImages.push(src)
            const viewer = this.$el.querySelector('.pimages').$viewer
            viewer.show()
            
        },
        // 订单修改
        toedit(id){
            this.editid=id
            this.editvisible=true
            this.getdetail(id)
            
        },
        edithandleOk(){
             this.$axios.post('/api/user/editcontract',{
                id:this.editid,
                title:this.orderinfo.title,
                content:this.orderinfo.content,
                contract:this.orderinfo.contract,
                voucher:this.orderinfo.voucher,
                qualifications:this.orderinfo.qualifications,
                remarks:this.orderinfo.remarks
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                    this.editvisible=false
                    this.fetch()
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        getdetail(id){
             this.$axios.post('/api/user/contractpage',{
                id: id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    
                    this.orderinfo=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        onaddressChange(value){
            this.province=value[0]
            this.city=value[1]
            this.area=value[2]
        },

        
        // 多选框
        onSelectChange(selectedRows){
            this.selectedRowKeys = selectedRows;
        },

        // 删除
        delusers(){
            if(this.selectedRowKeys.length==0){
                this.$message.error("请选择数据");
            }{
                var id=this.selectedRowKeys.join(",")
                Modal.confirm({
                    title: '提示',
                    content: '您确定删除吗?',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk:() => {
                        this.handok(id)
                    },
                    onCancel() {

                    },
                });
            }
           
        },
        delclue(value){
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(value)
                },
                onCancel() {

                },
            });
        },
        handok(value){
            this.$axios.post('/api/user/delcontract',{
                ids:value
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('删除成功');
                    // this.disabled=true
                    this.selectedRowKeys=[]
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        // 来源筛选
        lyhandleChange(){

        },

        // 标签筛选
        typehandleChange(value){
            this.currentpage=1
            this.state_pay=value
            this.fetch()
        },

        // 订单状态筛选
        orderhandleChange(value){
            this.currentpage=1
            this.state=value
            this.fetch()
        },

        // 号码查询
        handleserach(){

        },
        onSearch(){
            this.fetch()
        },

        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },


        // 数据
        fetch(){
            this.$axios.post('/api/user/contractlist',{
                pagesize: this.size,
                page:this.currentpage,
                // state_pay:this.state_pay,
                // state:this.state,
                search:this.searchtext,
                // telephone_jh:this.telephone_jh
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                     var data=res.data.data.data
                    // for(var i in data){
                    //     data[i].telephones=JSON.parse(data[i].telephones)
                    // }
                    this.data=data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        // 增加iccid
        addiccid(){
            var len=this.len++
            this.ordernum.push({"id":len})
        },
        remove(i){
            console.log(this.ordernum)
            this.ordernum=this.ordernum.splice(i, i)

        },

        // getdetail(id){
        //      this.$axios.post('/api/order/orderpage',{
        //         orid: id
        //     },{
        //         headers: {
        //             "token":localStorage.getItem('token'),
        //         }
        //     }).then((res)=>{
        //         if(res.data.code==200){
        //             this.msgname=res.data.data.orderpage.username
        //             this.msgtel=res.data.data.orderpage.telephone
        //             this.msgorderno=res.data.data.orderpage.orderno
        //             this.orderinfo=res.data.data.orderpage
        //             this.address=res.data.data.orderpage.address
        //             var ssq=[]
        //             ssq.push(res.data.data.orderpage.province)
        //             ssq.push(res.data.data.orderpage.city)
        //             ssq.push(res.data.data.orderpage.area)
        //             this.ssq=ssq
        //             this.order.orid=res.data.data.orderpage.orid
        //             this.order.tracknumber=res.data.data.orderpage.tracknumber
        //             this.orderno=res.data.data.orderpage.orderno
        //             var goodslist=res.data.data.goodslist
        //             for(var i in goodslist){
        //                 this.$delete(goodslist[i], 'goodsname')
        //                 this.$delete(goodslist[i], 'orid')
        //                 this.$delete(goodslist[i], 'state')
        //                 this.$delete(goodslist[i], 'updatetime')
        //                 this.$delete(goodslist[i], 'addtime')
        //             }
        //             this.goodslist=goodslist
        //         }else{
        //             this.$message.warning(res.data.msg); 
        //         }
               
        //     })
        // },
        todelive(id,num){
            this.getdetail(id)
            this.delivevisible=true
     
        },

        handleCancel(){
            this.delivevisible=false
            this.editvisible=false
        },

        // 快递方式
        kdhandleChange(){

        },

        khhandleOk(){
            this.$axios.post('/api/order/delivergoods',{
                order:this.order,
                goodslist:this.goodslist
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$axios.get('https://fxbkfadmin.13524.net/alidysms/api_demo/SmsDemo.php?telephone='+this.msgtel+'&username='+this.msgname+'&orderno='+this.msgorderno+'&tracknumber='+this.order.tracknumber,{
                        // telephone:this.msgtel,
                        // username:this.msgname,
                        // orderno:this.msgorderno,
                        // tracknumber:this.order.tracknumber
                    },{
                        headers: {
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                        }else{
                            this.$message.warning(res.data.msg); 
                        }
                    
                    })
                    this.$message.success(res.data.msg); 
                    this.delivevisible=false
                    this.order.tracknumber=""
                    this.fetch()
                    
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

    }
}
</script>





// WEBPACK FOOTER //
// src/components/order/orderlist.vue